export { default } from 'src/enterprise/signup/page';
